import { formatCurrency } from "@/helper/index";

export function getTotalToolTip({ totalValue, dollar, miles, gallons, sum }) {
	const total = formatCurrency(totalValue, true);
	if (miles) return `Σ: ${ total } mi`;
	if (dollar) return `Σ: $ ${ total }`;
	if (gallons) return `Σ: ${ total } g`;
	if (sum) return `Σ: ${ total }`;
	return `n: ${ total }`;
}
